import { useState } from "react";
import axios from "axios";
import { getAccessToken } from "../utils/authSession";

const usePostEngageLogin = (url) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const access_token = getAccessToken();

  const postData = async (body) => {
    try {
      setLoading(true);
      const response = await axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      setData(response);
      setError(null);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, postData };
};

export default usePostEngageLogin;
